import React from 'react';
import './ChatLoader.css';

export const ChatLoader = () => {
  // eslint-disable-next-line react/react-in-jsx-scope
  return <div className="chat-loader" />;
};
